export enum AIPropertyListingWizardSteps {
  Pictures,
  FloorPlans,
  Features,
  GeneratedDescription,
  GeneratedRooms,
}
